/* 快捷搜索自定义行为逻辑处理 */

export const getQuickSearchStore = () => import(
  /* webpackChunkName: "searchadvanced" */
  './common/QuickSearchStore'
)